import { sygnet } from './sygnet'
import { logo } from './logo'
import { logoNegative } from './logo-negative'

import {
  cilApplicationsSettings,
  cilSpeedometer,
  cilSun,
  cilPuzzle,
  cilMoon,
  cilChartPie,
  cilCode,
  cilStar,
  cilBan,
  cilBell,
  cilUserFollow,
  cilUserUnfollow,
  cilBasket,
  cilEnvelopeOpen,
  cilList,
  cilTask,
  cilCommentSquare,
  cilUser,
  cilSettings,
  cilCreditCard,
  cilFile,
  cilLockLocked,
  cilSpeech,
  cilGraph,
  cilCloudDownload,
  cilUserFemale,
  cilGlobeAlt,
  cibFacebook,
  cibTwitter,
  cibLinkedin,
  cilOptions,
  cilPeople,
  cifUs,
  cibCcMastercard,
  cifBr,
  cibCcVisa,
  cifIn,
  cibStripe,
  cifFr,
  cibPaypal,
  cifEs,
  cibGooglePay,
  cifPl,
  cibCcAmex,
  cilLocationPin,
  cilCalendar,
  cilPlus,
  cilMinus,
  cilSpreadsheet,
  cilFax,
  cilReload,
  cilSync,
  cilPrint,
  cilPin,
  cilBank,
  cilChevronLeft,
  cilClone,
  cilExternalLink,
  cilCloudUpload,
  cilCloud,
  cilRunning,
  cilGroup,
  cilFactory,
  cilLibrary
} from '@coreui/icons'

export const icons = Object.assign({}, {
  sygnet,
  logo,
  logoNegative
}, {
  cilPrint,
  cilChevronLeft,
  cilSync,
  cilApplicationsSettings,
  cilSpeedometer,
  cilSun,
  cilMoon,
  cilPuzzle,
  cilChartPie,
  cilCode,
  cilStar,
  cilBan,
  cilBell,
  cilUserFollow,
  cilUserUnfollow,
  cilBasket,
  cilList,
  cilEnvelopeOpen,
  cilTask,
  cilCommentSquare,
  cilUser,
  cilSettings,
  cilCreditCard,
  cilFile,
  cilLockLocked,
  cilSpeech,
  cilGraph,
  cilCloudDownload,
  cilUserFemale,
  cilGlobeAlt,
  cibFacebook,
  cibTwitter,
  cibLinkedin,
  cilOptions,
  cilPeople,
  cifUs,
  cibCcMastercard,
  cifBr,
  cibCcVisa,
  cifIn,
  cibStripe,
  cifFr,
  cibPaypal,
  cifEs,
  cibGooglePay,
  cifPl,
  cibCcAmex,
  cilLocationPin,
  cilCalendar,
  cilPlus,
  cilMinus,
  cilSpreadsheet,
  cilFax,
  cilReload,
  cilPin,
  cilBank,
  cilClone,
  cilExternalLink,
  cilCloudUpload,
  cilCloud,
  cilRunning,
  cilGroup,
  cilFactory,
  cilLibrary
})
